<div class="news-details">
  <div class="news-details-container" *ngIf="news">
    <div class="news-details-header">
      <div
        [ngStyle]="{
          'writing-mode': height < 100 ? 'tb' : 'lr'
        }"
        *ngIf="news.backgroundFile; else noBackgroundFile"
        class="news-details-background"
      >
        <img
          #background
          aria-label="Capa da Notícia"
          src="{{ backgroundFilePath }}"
        />
      </div>
      <ng-template #noBackgroundFile>
        <div class="news-details-no-background"></div>
      </ng-template>
      <div class="flex-div">
        <div class="flex-div-top-line">
          <div class="news-details-title">Título</div>
          <div class="news-details-value">{{ news.title }}</div>
        </div>
        <div class="flex-div-bottom-line">
          <div class="news-details-default">
            <div class="news-details-sent">
              <div class="news-details-title">Envios</div>
              <div class="loading-spinner" *ngIf="loadingSummary">
                <mat-spinner [diameter]="15" color="primary"></mat-spinner>
              </div>
              <div class="news-details-value" *ngIf="!loadingSummary">
                {{ sent }}
              </div>
            </div>
            <div class="news-details-visualized">
              <div class="news-details-title">Visualizações</div>
              <div class="loading-spinner" *ngIf="loadingSummary">
                <mat-spinner [diameter]="15" color="primary"></mat-spinner>
              </div>
              <div class="news-details-value" *ngIf="!loadingSummary">
                {{ visualized }}
              </div>
            </div>
          </div>
          <div
            class="news-details-authorizations"
            *ngIf="news.hasAuthorization"
          >
            <mat-divider vertical></mat-divider>
            <div class="news-details-authorizations-true">
              <div class="news-details-title">Autorizações</div>
              <div class="loading-spinner" *ngIf="loadingSummary">
                <mat-spinner [diameter]="15" color="primary"></mat-spinner>
              </div>
              <div class="news-details-value" *ngIf="!loadingSummary">
                {{ authorizedTrue }}
              </div>
            </div>
            <div class="news-details-authorizations-peding">
              <div class="news-details-title">Pendentes</div>
              <div class="loading-spinner" *ngIf="loadingSummary">
                <mat-spinner [diameter]="15" color="primary"></mat-spinner>
              </div>
              <div class="news-details-value" *ngIf="!loadingSummary">
                {{ pending }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news-details-tabs">
      <mat-tab-group>
        <mat-tab label="Informações Gerais">
          <app-news-info [news]="news"></app-news-info>
        </mat-tab>
        <mat-tab label="Engajamento">
          <app-news-engagement-list [news]="news"></app-news-engagement-list>
        </mat-tab>
        <mat-tab label="Histórico">
          <app-news-authorization-history [news]="news"></app-news-authorization-history>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
